import React from 'react';

const ButtonLink = ({ href, children, newTab = true }) => {
  return (
    <a
      href={href}
      target={newTab ? "_blank" : "_self"}
      rel="noopener noreferrer"
      className="btn-link"
    >
      {children}
    </a>
  );
};

export default ButtonLink;
